import { Action } from "redux";

export const SET_INITIALIZED = "SET_INITIALIZED";

export interface InitializeAction extends Action<string> {
    initialized: boolean;
}
